let fallbackHost: string | undefined = 'minmini.de/api'
let host = fallbackHost

let schemeForHttp = 'http://'

if (host === 'minmini.de/api') {
	schemeForHttp = 'https://'
}

export const apiHost = schemeForHttp + host + '/api'
